// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"bF_g5","list":"bF_cC","link":"bF_cn","title":"bF_f","externalLink":"bF_hz","description":"bF_g","actions":"bF_gd","body":"bF_dl","actionLink":"bF_hB"};